<template>
  <div>
    <v-container class="pa-0" fluid>
      <v-row no-gutters>
        <v-col>
          <!-- <v-card> -->
          <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
            <v-row no-gutters>
              <v-col cols="12" lg="5" class="my-0 py-0">
                <div class="d-flex grow flex-wrap">
                  <div class="ml-2">
                    <div
                      class="font-weight-regular headline text-decoration-underline text-capitalize">
                      {{formData.name}}
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-card-text>
              <div v-for="(modules,i) in trainingModuleMapsData" :key="i">
                <v-card class="rounded-lg  mb-2" outlined>
                  <v-card-title>
                    {{i+1}}.{{modules.trainingModule.name}}
                  </v-card-title>
                  <v-row dense>
                    <div v-for="(file,j) in modules.trainingModule.trainingModuleFileMaps" :key="j">
                      <!-- <v-row>
                      <v-subheader v-if="!file.isLink" > {{file.name}}</v-subheader>
                      <v-subheader v-else  ref="textToCopy" id="textToCopy"> {{file.key}}</v-subheader>
                      </v-row> -->
                      <div class="pa-2" v-if="!file.isLink">
                        <v-card min-width="200px" color="orange" class="rounded-lg  pl-1"
                           dark @click="downloadFile(file)">
                          <div style="background-color:white;">
                            <!-- <v-card-title>
                              <span>
                                <v-icon color="primary" large>mdi-download-circle</v-icon>
                              </span>
                            </v-card-title> -->
                            <v-card-subtitle class="primary--text "><v-icon class="pr-1" color="primary" large>mdi-download-circle</v-icon>{{file.name}}</v-card-subtitle>
                          </div>
                        </v-card>
                      </div>
                      <div v-else class="pa-2" >
                        <v-card min-width="200px" color="orange" class="rounded-lg pl-1"
                           v-if="file.isLink" dark @click="copyLink(file)">
                          <div style="background-color:white;">
                            <!-- <v-card-title>
                              <span>
                                <v-icon color="primary" large>mdi-arrow-top-right</v-icon>
                              </span>
                            </v-card-title> -->
                            <v-card-subtitle class="primary--text"><v-icon color="primary" class="pr-1 " large>mdi-arrow-top-right</v-icon>{{shortPath(file.key)}}
                             </v-card-subtitle>
                          </div>
                        </v-card>
                      </div>
                      <!-- <v-btn
                @click="downloadFile(file)"
                class="px-2 ml-1 white--text ma-1"
                color="success"
                min-width="0"
                small
              >Download File<v-icon small>
              mdi-cloud-download</v-icon>
              </v-btn>
                </v-col> -->
                      <!-- <v-col v-else>
              <v-btn v-if="file.isLink"
                @click="copyLink(file)"
                class="px-2 ml-1 white--text ma-1"
                color="success"
                min-width="0"
                small
              >Open Link
                <v-icon small >
              mdi-content-copy</v-icon>
              </v-btn>
                </v-col> -->
                    </div>
                  </v-row>
                </v-card>
              </div>
              <!-- </v-col> -->
            </v-card-text>
            <v-spacer></v-spacer>
            <v-card-actions>
              <v-spacer></v-spacer>
              <router-link slot="right"
                :to="{ name: 'addTeacherEnrollment' ,params:{'classID':this.formData.classID,'trainingID':this.trainingID}}">
                <v-btn color="primary" dark tile>
                  Enroll Teacher
                </v-btn>
              </router-link>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <loading-icon :value="isLoading" />
  </div>
</template>

<script>
import constants from '@/utils/constants'
import _ from 'lodash'
// import moment from 'moment'
import { mapGetters } from 'vuex'
// import Vue from 'vue'
// import CKEditor from 'ckeditor4-vue'
// Vue.use(CKEditor)

export default {
  name: 'TeacherTrainingTopic',
  props: ['trainingTopicID'],
  components: {},
  data () {
    return {
      tab: null,
      classData: [],
      moduleData: [],
      selectedModules: [],
      deletedExistingTrainingModule: [],
      selectmodule: null,
      trainingID: null,
      valid: false,
      classRules: [(v) => !!v || 'Item is required'],
      formData: {
        name: '',
        classID: '',
        isActive: false
      },
      trainingModuleMapsData: [],
      isLoading: false
    }
  },

  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  mounted: async function () {},
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    }
  },
  async created () {
    try {
      if (this.trainingTopicID) {
        await this.getTrainingTopicData(this.trainingTopicID)
      }
    } catch (error) {
      console.log(error)
    }
  },
  methods: {
    shortPath: function (key) {
      return key.split('\\').pop().split('/').pop()
    },
    getTrainingTopicData: async function (trainingID) {
      try {
        this.isLoading = true
        let result = await http.get(`${constants.API_URL}/api/teacher-training/training/get/${trainingID}`)
        this.isLoading = false
        this.formData.name = result.data.name
        this.trainingID = result.data.id
        this.formData.classID = result.data.studentClassGroup.id
        this.formData.className = result.data.studentClassGroup.name
        this.formData.isActive = result.data.isActive
        this.trainingModuleMapsData = result.data.trainingModuleMaps
        if (!_.isEmpty(result.data.trainingModuleMaps)) {
          _.map(result.data.trainingModuleMaps, (d) => {
            d.moduleName = d.trainingModule.name
          })

          this.selectedModules = result.data.trainingModuleMaps
        }
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log(e)
        this.errMsg(errorMessage)
      }
    },
    downloadFile: async function (file) {
      try {
        let fileID = file.id
        let downloadURL = await http.get(`${constants.API_URL}/api/teacher-training/module/download-file/${fileID}`)

        window.open(downloadURL.data)
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log(e)
        this.errMsg(errorMessage)
      }
    },
    copyLink: async function (file) {
      try {
        let url = file.key
        window.open(url)
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log(e)
        this.errMsg(errorMessage)
      }
    },
    onFranchiseeChange: async function () {
      try {
        if (!this.inProgress) {
          this.inProgress = true
          if (this.franchisee) {
            this.franchiseeID = this.franchisee.id
          } else {
            this.franchiseeID = ''
          }
          if (this.academicYear) {
            this.academicYearID = this.academicYear.id
          } else {
            this.academicYearID = ''
          }
          this.inProgress = false
        }
      } finally {
        this.inProgress = false
      }
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>
